<template>
  <div class="contaier">
    <div class="form-box relative">
      <!-- <div class="title xl:text-3xl md:text-2xl text-2xl font-semibold">
        {{ $t("home.form_title") }}
      </div> -->
      <div class="title lg:text-[32px] text-2xl md:pb-[30px] pb-[20px] font-semibold">{{ $t('home.form_title2') }}</div>
      <p class="note text-10px pb-[10px]" id="myElement">
        {{ $t('home.mandatory') }}
      </p>
      <el-form :model="form" ref="formRef" :rules="formRules" label-width="80px" label-position="top">
        <el-row :gutter="20">
          <el-col :md="4" :sm="6" :xs="8">
            <el-form-item :label="$t('home.appellation')" prop="title">
              <el-select
                :popper-append-to-body="false"
                style="width: 100%"
                :value="form.title"
                @change="changeTitle"
                :placeholder="$t('home.selectAppellation')"
              >
                <el-option :label="$t('appellation.Sir')" :value="$t('appellation.Sir')"></el-option>
                <el-option :label="$t('appellation.lady')" :value="$t('appellation.lady')"></el-option>
                <el-option :label="$t('appellation.Miss')" :value="$t('appellation.Miss')"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="10" :sm="18" :xs="16">
            <el-form-item :label="$t('home.lastName')" prop="lastName">
              <el-input v-model="form.lastName" :placeholder="$t('home.enterLastName')" maxlength="10"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="10" :sm="24">
            <el-form-item :label="$t('home.firstName')" prop="firstName">
              <el-input v-model="form.firstName" :placeholder="$t('home.enterFirstName')" maxlength="10"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="12">
            <el-form-item :label="$t('home.mobileNumber')" prop="phoneAreaCode">
              <div class="phone-box">
                <div class="phone-sum">
                  <el-select
                    :popper-append-to-body="false"
                    style="width: 100%"
                    :value="form.phoneAreaCode"
                    @change="changePhoneAreaCode"
                  >
                    <el-option label="+852" value="852">
                      <span>{{ $t('phoneHK') }}</span>
                    </el-option>
                    <el-option label="+86" value="86">
                      <span>{{ $t('phoneCN') }}</span>
                    </el-option>
                  </el-select>
                </div>
                <!-- <div class="phone-sum">+852</div> -->
                <div class="phone-">
                  <el-form-item prop="phone">
                    <el-input
                      style="width: 100%"
                      v-model="form.phone"
                      :placeholder="form.phoneAreaCode == '852' ? $t('home.enterPhoneHK') : $t('home.enterPhoneCN')"
                      :maxlength="form.phoneAreaCode == '852' ? 8 : 11"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="12">
            <el-form-item :label="$t('home.emailAddress')">
              <el-input v-model="form.email" :placeholder="$t('home.enterEmail')" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- class="hidden-xs-only" -->
        <el-row :gutter="20" v-if="!isZeekrDemo">
          <el-col :md="12" :sm="12">
            <el-form-item :label="$t('carOption.cartitle')" prop="carModel">
              <el-select
                :popper-append-to-body="false"
                style="width: 100%"
                :value="form.carModel"
                @change="changeCar"
                :placeholder="$t('carOption.carModel_')"
              >
                <el-option
                  v-for="(item, index) in carList"
                  :key="index"
                  :label="$i18n.locale === 'en' ? item.name_en || item.name : item.name"
                  :value="item.name"
                ></el-option>
                <!-- <el-option label="V23 Sport (AWD)" value="V23 Sport (AWD)"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="12">
            <el-form-item :label="$t('home.selectLanguage')" prop="language">
              <el-select
                :popper-append-to-body="false"
                style="width: 100%"
                :value="form.language"
                @change="changeLan"
                :placeholder="$t('home.pleaseSelectLanguage')"
              >
                <el-option :label="$t('home.lang_en')" value="English"></el-option>
                <el-option :label="$t('home.lang_cn')" value="繁體中文"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- ZEEKR Demo 专属问题 -->
        <el-row :gutter="20" v-if="isZeekrDemo">
          <!-- <el-col :md="12" :sm="12">
            <el-form-item :label="isEn ? 'ZEEKR models owned :' : '所擁有之ZEEKR型號 :'" prop="carModel">
              <el-select
                :popper-append-to-body="false"
                style="width: 100%"
                v-model="form.carModel"
                :placeholder="isEn ? 'Please select' : '請選擇'"
              >
                <el-option label="Zeekr X" value="Zeekr X"></el-option>
                <el-option label="Zeekr 7X" value="Zeekr 7X"></el-option>
                <el-option label="Zeekr 009" value="Zeekr 009"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :md="12" :sm="12">
            <el-form-item :label="isEn ? 'Are you Zeekr Owner ?' : '是否 ZEEKR 車主?'" prop="isZeekrOwner">
              <el-select
                :popper-append-to-body="false"
                style="width: 100%"
                v-model="form.isZeekrOwner"
                :placeholder="isEn ? 'Please select' : '請選擇'"
              >
                <el-option :label="$t('home.Yes')" value="Yes"></el-option>
                <el-option :label="$t('home.No')" value="No"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :md="12" :sm="12">
            <el-form-item
              :label="isEn ? 'Car Plate Number (If you are Zeekr owner):' : '車牌號碼 (如是 ZEEKR 車主):'"
              prop="carPlate"
            >
              <el-input
                v-model="form.carPlate"
                :placeholder="isEn ? 'Please enter car plate number (e.g. AB1234)' : '請輸入車牌號碼'"
                maxlength="8"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :md="12" :sm="12">
            <el-form-item :label="isEn ? 'Appointment Time :' : '預約時間 :'" prop="appointmentTime">
              <el-select
                :popper-append-to-body="false"
                style="width: 100%"
                v-model="form.appointmentTimeItem"
                :placeholder="isEn ? 'Please select appointment time' : '請選擇預約時間'"
                @visible-change="onTimeSlotVisible"
                @change="onTimeSlotChange"
                value-key="dateTimeKey"
              >
                <!-- 先展示可预约的时间段 -->
                <el-option
                  v-for="item in availableTimeSlots"
                  :key="item.dateTimeKey"
                  :label="slotLabel(item)"
                  :value="item"
                ></el-option>
                <!-- 只參與賽車手講座：放在可预约时间段之后、不可预约时间段之前 
                  :disabled="seminarRemaining <= 0"-->
                <el-option :label="seminarOnlyLabel" :value="seminarOnlyOption"></el-option>
                <!-- 再展示已约满的时间段 -->
                <el-option
                  v-for="item in unavailableTimeSlots"
                  :key="item.dateTimeKey"
                  :label="slotLabel(item)"
                  :value="item"
                  disabled
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :md="12" :sm="12">
            <el-form-item
              :label="
                isEn
                  ? 'Will you participate in the racing driver seminar from 2:00 to 3:00 PM?:'
                  : '是否參與2:00 – 3:00P M 之賽車手講座:'
              "
              prop="attendees"
            >
              <el-select
                :popper-append-to-body="false"
                style="width: 100%"
                v-model="form.attendees"
                :placeholder="isEn ? 'Please select' : '請選擇'"
              >
                <!-- 是（1位/2位）：依据 remainingNum 单独计算是否可报名 -->
                <el-option :label="seminarOptionLabel(1)" value="1" :disabled="seminarRemaining < 1"></el-option>
                <el-option :label="seminarOptionLabel(2)" value="2" :disabled="seminarRemaining < 2"></el-option>

                <!-- 否：始终可选 -->
                <el-option :label="isEn ? 'NO' : '否'" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-if="brand.name != 'zeekr'">
          <el-col :md="12" :sm="12">
            <!-- <el-form-item :label="$t('home.sales')">
              <el-input v-model="form.sales" :placeholder="$t('home.rightSales')" maxlength="30"></el-input>
            </el-form-item> -->
            <el-form-item v-if="brand.name == 'zeekr'" :label="$t('home.sales')" prop="sales">
              <el-select
                :popper-append-to-body="false"
                style="width: 100%"
                value-key="userId"
                :value="form.sales"
                @visible-change="visibleChangeSalesMan($event)"
                @change="changeSalesMan"
                :placeholder="$t('home.rightSales')"
              >
                <div slot="empty" style="text-align: center; color: #909399; padding: 10px 0">
                  <i class="el-icon-loading"></i>
                  <span class="ml-1">載入中</span>
                </div>
                <el-option
                  v-for="(item, index) in salesManList"
                  :key="index"
                  :label="item.nickName"
                  :value="item"
                ></el-option>
                <!-- <el-option label="V23 Sport (AWD)" value="V23 Sport (AWD)"></el-option> -->
              </el-select>
            </el-form-item>

            <el-form-item v-else :label="$t('home.sales')">
              <el-select
                :popper-append-to-body="false"
                style="width: 100%"
                value-key="userId"
                :value="form.sales"
                @visible-change="visibleChangeSalesMan($event)"
                @change="changeSalesMan"
                :placeholder="$t('home.rightSales')"
              >
                <div slot="empty" style="text-align: center; color: #909399; padding: 10px 0">
                  <i class="el-icon-loading"></i>
                  <span class="ml-1">載入中</span>
                </div>

                <el-option
                  v-for="(item, index) in salesManList"
                  :key="index"
                  :label="item.nickName"
                  :value="item"
                ></el-option>
                <!-- <el-option label="V23 Sport (AWD)" value="V23 Sport (AWD)"></el-option> -->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="12">
            <el-form-item :label="$t('home.vw')">
              <el-input v-model="form.wxNumber" :placeholder="$t('home.enterVw')" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="20">
          <el-col :md="12" :sm="12">
            <el-form-item class="relative" :label="$t('dateTime.dateTitle')" prop="date">
              <el-date-picker
                style="width: 100%"
                @focus="hideFullAdjacentRows"
                v-model="selectedDate"
                type="date"
                :placeholder="$t('dateTime.date_')"
                ref="datePicker"
                format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                popper-class="hide-adjacent-months"
                @change="changeDate"
              />
              <div class="text-[11.5px] sm:text-[13px] absolute top-0 right-[38px] text-[#606266] pointer-events-none">
                {{ dateText }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :md="12" :sm="12">
            <el-form-item :label="$t('dateTime.timePeriodTitle')" prop="timePeriod">
              <el-select
                style="width: 100%"
                :value="form.timePeriod"
                :placeholder="$t('dateTime.timePeriod_')"
                @change="changeTime"
                @focus="changeTimeVer"
                :no-data-text="noDataText"
              >
                <template slot="prefix">
                  <i class="el-icon-time"></i>
                </template>
                <el-option
                  v-for="(item, index) in timePeriodList"
                  :label="item.value"
                  :value="item.value"
                  :key="index"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->
        <!-- <el-form-item :label="$t('home.corporateClient')" prop="enterprise">
          <el-radio-group v-model="form.enterprise">
            <el-radio :label="$t('home.yes')"></el-radio>
            <el-radio :label="$t('home.no')"></el-radio>
          </el-radio-group>
        </el-form-item> -->

        <!-- <el-form-item
          :label="$t('home.corporateClient')"
          prop="enterprise"
          class="hidden-sm-and-up"
        >
          <el-radio-group v-model="form.enterprise">
            <el-radio :label="$t('home.yes')"></el-radio>
            <el-radio :label="$t('home.no')"></el-radio>
          </el-radio-group>
        </el-form-item> -->

        <!-- <el-form-item
          v-if="form.enterprise === '是' || form.enterprise === 'Yes'"
          :label="$t('home.pleaseWriteName_')"
          prop="enterpriseUser"
          :rules="[
            {
              required: form.enterprise == '是' || form.enterprise === 'Yes',
              message: $t('home.pleaseWriteName'),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="form.enterpriseUser"
            :placeholder="$t('home.pleaseWriteName')"
          ></el-input>
        </el-form-item> -->
        <!-- 88:{{ form.language }} -->
        <!-- <el-form-item :label="$t('home.remark')">
          <el-input v-model="form.remark"></el-input>
        </el-form-item> -->

        <el-form-item prop="agreePrivacy">
          <el-checkbox-group style="width: 100%" v-model="form.agreePrivacy">
            <el-checkbox name="agreePrivacy" :label="true">
              {{ $t('home.agree_') }}
              <!--<a class="to-page" @click="centerDialogRR = true">{{ $t('home.rentCar_') }}</a>
              、 -->
              <a class="to-page" @click="goNewPage">{{ $t('home.policy_') }}</a>
              {{ $t('home.and') }}
              <a class="to-page" @click="goNewPage1">{{ $t('home.statement_') }}</a>
              {{ $t('home.fullStop') }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item>
          <el-checkbox-group style="width: 100%" v-model="form.agreeUsePersonal">
            <el-checkbox name="agreeUsePersonal" :label="true">{{ $t('home.privacyPolicy') }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <div
          class="btn bg-[var(--btn-bg)] text-[var(--btn-color)] font-bold"
          :style="{ '--btn-bg': btn.btnBg, '--btn-color': btn.btnColor }"
          @click="submitForm"
        >
          {{ $t('home.submit') }}
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" top="40vh" width="320px" center>
      <div class="mt-[-26px]">
        <!-- <h3 class="text-[22px] text-[#000] text-center font-bold mb-2">提示</h3> -->
        <p class="text-[18px] text-[#111] text-center">{{ errorMsg }}</p>
      </div>
    </el-dialog>

    <!-- <el-dialog :visible.sync="centerDialogRR" custom-class="w-[96%]  sm:w-[80%] mdd:w-[70%]">
      <h2 class="text-center text-[26px] text-black mb-10 mt-[-20px] font-bold">租車條及與細則</h2>
      <RentReg class="bg-white"></RentReg>
    </el-dialog> -->

    <el-dialog
      class="cLoading"
      top="35vh"
      width="190px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible2"
    >
      <div class="dialog-box dialog-box2">
        <i class="el-icon-loading icon-check"></i>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { EventBus } from '@/assets/js/event-bus'
import { cloneDeep } from 'lodash'
import { addMotorShowApi, salesManListApi, currentUrlListApi } from '@/Api/requestApi'
// import RentReg from '@/components/RentReg.vue'

import moment from 'moment'

export default {
  name: 'FormPage',
  components: {
    // RentReg,
  },
  props: {
    brand: {
      type: Object,
      default: () => ({}),
    },
    carList: {
      type: Array,
      default: () => [],
    },
    btn: {
      type: Object,
      default: () => ({ btnBg: '#000', btnColor: '#fff' }),
    },
    timeAc: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let validateSales = (rule, value, callback) => {
      if (this.brand.name === 'zeekr' && !value) {
        return callback(new Error(this.$t('home.rightSales')))
      }
      callback()
    }
    let validateTitle = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('home.selectAppellation')))
      }
      callback()
    }
    let enterLastName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('home.enterLastName')))
      }
      callback()
    }
    let enterFirstName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('home.enterFirstName')))
      }
      callback()
    }
    // let pleaseSelectLanguage = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error(this.$t("home.pleaseSelectLanguage")));
    //   }
    //   callback();
    // };

    // let Postcode = (postcode) => {
    //   const regex = /^[0-9][0-9]{5}$/;
    //   return valid(postcode, regex, "請輸入正確的郵箱！");
    // };
    let Postcode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('home.enterEmail')))
      }
      const regExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (!regExp.test(value)) {
        return callback(new Error(this.$t('home.rightEmail')))
      } else {
        callback()
      }
    }
    let phoneAreaCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('carOption.enterPhoneHK')))
      }
      callback()
    }
    let phonecode = (rule, value, callback) => {
      const isHK = this.form.phoneAreaCode === '852'

      if (!value) {
        return callback(new Error(isHK ? this.$t('home.enterPhoneHK') : this.$t('home.enterPhoneCN')))
      }
      const regExp = isHK ? /^(4|5|6|7|8|9)\d{7}$/ : /^1[3-9]\d{9}$/
      if (!regExp.test(value)) {
        return callback(new Error(isHK ? this.$t('home.rightPhoneHK') : this.$t('home.rightPhoneCN')))
      } else {
        callback()
      }
    }
    let carModelCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('carOption.carModel_')))
      }
      callback()
      // const regExp = /^(4|5|6|8|9)\d{7}$/;
      // if (!regExp.test(value)) {
      //   return callback(new Error(this.$t("home.rightPhone")));
      // } else {
      //   callback();
      // }
    }
    let isZeekrOwnerCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('home.selectZeekrOwner')))
      }
      callback()
    }
    let carPlateCode = (rule, value, callback) => {
      if (!this.isZeekrDemo) return callback()
      // 可以为空，非必填
      if (!value || !value.trim()) return callback()
      const regExp = /^(?!.*[IO])[A-Z0-9\s]{1,8}$/i
      if (!regExp.test(value.trim())) {
        return callback(
          new Error(
            this.$i18n.locale === 'en'
              ? 'Invalid HK car plate number (max 8 characters, without I/O)'
              : '車牌號碼格式不正確（最多8位，不含 I、O）'
          )
        )
      }
      callback()
    }
    let attendeesCode = (rule, value, callback) => {
      if (!this.isZeekrDemo) return callback()
      // 该选项必填（含 “否”）
      if (value === '' || value === null || value === undefined) {
        return callback(new Error(this.$i18n.locale === 'en' ? 'Please select' : '請選擇'))
      }
      // 选择 1/2 位时需验证讲座剩余名额
      const num = Number(value)
      if (num > 0 && this.seminarRemaining < num) {
        return callback(
          new Error(this.$i18n.locale === 'en' ? 'The racing driver seminar is fully booked' : '賽車手講座名額已滿')
        )
      }
      callback()
    }
    let appointmentTimeCode = (rule, value, callback) => {
      if (!this.isZeekrDemo) return callback()
      if (!value) {
        return callback(new Error(this.$i18n.locale === 'en' ? 'Please select appointment time' : '請選擇預約時間'))
      }
      callback()
    }
    // let dateCode = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error(this.$t('dateTime.date_')))
    //   }
    //   callback()
    // }

    // let timePeriodCode = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error(this.$t('dateTime.timePeriod_')))
    //   }
    //   callback()
    // }

    // let corporateClient_ = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error(this.$t("home.corporateClient_")));
    //   }
    //   callback();
    // };

    let _policy = (rule, value, callback) => {
      if (!value.length) {
        return callback(new Error(this.$t('home._policy')))
      }
      callback()
    }

    return {
      centerDialogRR: false,
      dialogVisible: false,
      dialogVisible2: false,
      pickerOptions: {
        // 使用箭头函数确保 this 指向正确
        disabledDate: (time) => {
          // 1. 只允许 2026 年 4 月或 5 月
          const year = time.getFullYear()
          const month = time.getMonth() + 1
          const isAllowedMonth = year === 2026 && (month === 4 || month === 5)

          if (!isAllowedMonth) {
            return true // 不在允许的月份范围内，禁用
          }

          // 2. 禁止选择小于当前日期的日期（今天之前的日期）
          const today = moment().startOf('day') // 今天 00:00:00
          const pickDate = moment(time).startOf('day')
          if (pickDate.isBefore(today)) {
            // 小于，禁用
            return true
          }
          // isSameOrBefore // 小于及今天，禁用

          // 3. 排除 disabledPublicHoliday 中的具体日期
          // const dateStr = moment(time).format('YYYY/MM/DD')
          // if (this.curDisabledAll.includes(dateStr)) {
          //   return true  // 在禁用列表中，禁用
          // }

          // 所有条件都通过，该日期可选
          return false
        },
      },
      salesManList: [],
      timeSlotOptions: [],
      errorMsg: '',
      curQuota: '',
      // 賽車手講座剩余可报名人数（来自 currentUrlListApi 返回的 remainingNum）
      seminarRemaining: 0,
      form: {
        sales: '',
        // salesId: '',
        title: '',
        lastName: '',
        firstName: '',
        phoneAreaCode: '852',
        phone: '',
        wxNumber: '',
        email: '',
        carModel: '',
        isZeekrOwner: '',
        brand: this.brand.name,
        brandId: this.brand.id,
        remark: '',
        language: this.$i18n.locale === 'zh' ? '繁體中文' : 'English',
        // date: '',
        // timePeriod: '',
        // enterprise: "", //我加的
        // enterpriseUser: "",
        // carReplace: "",
        agreePrivacy: [],
        agreeUsePersonal: [],
        acId: '',
        carPlate: '',
        attendees: '',
        appointmentTime: '',
        appointmentTimeItem: '',
      },
      formRules: {
        sales: [{ required: true, validator: validateSales, trigger: 'change' }],
        title: [{ required: true, validator: validateTitle, trigger: 'change' }],
        lastName: [{ required: true, validator: enterLastName, trigger: 'blur' }],
        firstName: [{ required: true, validator: enterFirstName, trigger: 'blur' }],
        // language: [
        //   {
        //     required: true,
        //     validator: pleaseSelectLanguage,
        //     trigger: "change",
        //   },
        // ],
        phoneAreaCode: [{ required: true, validator: phoneAreaCode, trigger: 'change' }],
        phone: [{ required: true, validator: phonecode, trigger: 'change' }],
        email: [{ required: true, validator: Postcode, trigger: 'change' }],
        isZeekrOwner: [{ required: true, validator: isZeekrOwnerCode, trigger: 'change' }],
        carModel: [{ required: true, validator: carModelCode, trigger: 'change' }],
        carPlate: [{ required: false, validator: carPlateCode, trigger: 'blur' }],
        attendees: [{ required: true, validator: attendeesCode, trigger: 'change' }],
        appointmentTime: [{ required: true, validator: appointmentTimeCode, trigger: 'change' }],
        // date: [{ required: true, validator: dateCode, trigger: 'change' }],
        // timePeriod: [{ required: true, validator: timePeriodCode, trigger: 'change' }],
        // enterprise: [{ required: true, validator: corporateClient_, trigger: "blur" }],
        agreePrivacy: [
          {
            type: 'array',
            // required: true,
            validator: _policy,
            trigger: 'change',
          },
        ],
      },
      unwatchPickerDate: null,
    }
  },
  created() {
    EventBus.$on('message', this.receiveMessage)
  },
  beforeDestroy() {
    EventBus.$off('message', this.receiveMessage)
    // 组件销毁前，务必移除监听
    // if (this.unwatchPickerDate) {
    //   this.unwatchPickerDate()
    //   this.unwatchPickerDate = null
    // }
  },
  computed: {
    isZeekrDemo() {
      return this.brand.url === 'zeekr/event'
    },
    isEn() {
      return this.$i18n.locale === 'en'
    },
    // 可预约的时间段（quota > 0）
    availableTimeSlots() {
      return this.timeSlotOptions.filter((item) => item.quota && item.quota > 0)
    },
    // 不可预约的时间段（quota 为空或 <= 0）
    unavailableTimeSlots() {
      return this.timeSlotOptions.filter((item) => !item.quota || item.quota <= 0)
    },
    // “只參與賽車手講座” 选项对象（使用 dateTimeKey 作为 value-key识别）
    seminarOnlyOption() {
      return { dateTimeKey: 'SEMINAR_ONLY', seminarOnly: true }
    },
    seminarOnlyLabel() {
      const text = this.isEn ? 'Attend racing driver seminar only' : '只參與賽車手講座'
      return text
      // return this.seminarRemaining <= 0 ? (this.isEn ? `${text} (Fully booked)` : `${text}（已約滿）`) : text
    },
    // curDisabledAll() {
    //   console.log('合集禁止', [...this.disabledPublicHoliday, ...this.disabledWeekend])
    //   return [...this.disabledPublicHoliday, ...this.disabledWeekend]
    // },
  },
  mounted() {
    this.getSalesManList(this.form.brandId)
    this.fetchCurrentActivity()
  },
  methods: {
    async getSalesManList(brandId) {
      if (this._salesLoading) return
      this._salesLoading = true
      try {
        const {
          data: { code, data },
        } = await salesManListApi({ brandId })
        if (code === 200) {
          this.salesManList = data
        }
      } finally {
        this._salesLoading = false
      }
    },
    async fetchCurrentActivity() {
      try {
        const url = '/' + this.brand.url
        const params = { url }
        if (this.timeAc) {
          params.timeAc = this.timeAc
        }
        console.log('aaaaa', params)

        const {
          data: { code, data },
        } = await currentUrlListApi(params)
        if (code === 200 && data && data.length > 0) {
          this.form.acId = data[0].curAcId || ''
          if (data[0].titleAc) {
            this.form.remark = data[0].titleAc
          }
          this.timeSlotOptions = this.parseTimeSlots(data[0].optionaTimeAc)

          this.timeSlotOptions = this.timeSlotOptions.map((item) => ({
            ...item,
            dateTimeKey: this.formatSlotKey(item),
          }))
          // 講座剩余可报名名额（与时间段 quota 独立计算）
          this.seminarRemaining = Number(data[0].remainingNum) || 0
        }
      } catch (err) {
        console.error('獲取當前活動配置失敗:', err)
      }
    },
    parseTimeSlots(val) {
      if (!val) return []
      if (Array.isArray(val)) return val
      if (typeof val === 'string') {
        try {
          const parsed = JSON.parse(val)
          return Array.isArray(parsed) ? parsed : []
        } catch (e) {
          return []
        }
      }
      return []
    },
    formatSlot(item) {
      // \u3000 为全角空格，不会被 HTML 折叠，拉开日期与时间的间距（仅用于显示）
      return `${item.date}\u2002${item.startTime} - ${item.endTime}PM`
    },
    // 仅用于生成 dateTimeKey 与提交后端，使用普通空格，不带宽空格字符
    formatSlotKey(item) {
      return `${item.date} ${item.startTime} - ${item.endTime}`
    },
    slotLabel(item) {
      const base = this.formatSlot(item)
      if (!item.quota || item.quota <= 0) {
        return this.isEn ? `${base} (Fully booked)` : `${base}（已約滿）`
      }
      return base
    },
    slotLabelQuota(quota) {
      const base = quota
      console.log('quota :>> ', quota, this.curQuota)
      if (!(quota <= this.curQuota)) {
        return this.isEn ? `${base} ppl (Fully booked)` : `${base} 人（已約滿）`
      }
      return this.isEn ? `YES (${base} ppl)` : `是 (${base} 位)`
    },
    // 賽車手講座选项 label：名额不足时提示已约满
    seminarOptionLabel(count) {
      const yesText = this.isEn ? `YES (${count} ppl)` : `是 (${count} 位)`
      if (this.seminarRemaining < count) {
        return this.isEn ? `${yesText} (Fully booked)` : `${yesText}（已約滿）`
      }
      return yesText
    },
    onTimeSlotVisible(visible) {
      if (visible) {
        this.fetchCurrentActivity()
      }
    },
    onTimeSlotChange(value) {
      console.log('value :>> ', value, this.formatSlot(value))
      this.form.appointmentTimeItem = value
      // “只參與賽車手講座” 选项：不占用时间段 quota，名额以 remainingNum 为准
      if (value && value.seminarOnly) {
        this.form.appointmentTime = 'SEMINAR_ONLY'
        this.curQuota = this.seminarRemaining
      } else {
        this.form.appointmentTime = value.dateTimeKey
        this.curQuota = value.quota * 1
      }
      this.form.attendees = ''
    },

    receiveMessage(msg) {
      console.log('msg :>> ', msg)
      this.changeLanguage(msg)
      // this.message = msg;
    },
    hideFullAdjacentRows() {
      document.querySelectorAll('.el-date-table__row').forEach((row) => {
        const cells = row.querySelectorAll('td')
        if (cells.length !== 7) return
        const allPrevOrNext = Array.from(cells).every(
          (td) => td.classList.contains('prev-month') || td.classList.contains('next-month')
        )
        row.style.display = allPrevOrNext ? 'none' : ''
      })
    },
    submitForm() {
      // this.dialogVisible = true;
      // this.dialogVisible2 = true;
      // let _lang = window.sessionStorage.getItem("sessionLang") || "zh";
      // this.$router.push({ path: "/succeed", query: { lang: _lang } });
      // this.$router.push({ path: "/succeed" });
      // return;
      this.$refs.formRef.validate(async (valid) => {
        // console.log("valid :>> ", valid);
        if (valid) {
          let formDate_ = cloneDeep(this.form)

          // formDate_.phone = `${formDate_.phone}`

          // console.log("form :>>通过了 11", this.form);
          // return;

          formDate_.agreePrivacy = formDate_.agreePrivacy[0]
          formDate_.agreeUsePersonal = formDate_.agreeUsePersonal[0]
          // delete formDate_.enterprise;
          // formDate_.agreePrivacy = formDate_.agreePrivacy.join("");
          // formDate_.agreeUsePersonal = formDate_.agreeUsePersonal.join("");

          console.log('form :>>通过了 ', formDate_)
          this.dialogVisible2 = true
          // return;
          const {
            data: { code, strId, message, messageEn },
          } = await addMotorShowApi(formDate_)

          if (code === 200) {
            // this.dialogVisible = true;
            this.form = {
              sales: '',
              // salesId: '',
              title: '',
              lastName: '',
              firstName: '',
              phoneAreaCode: '',
              phone: '',
              email: '',
              wxNumber: '',
              remark: this.form.remark,
              // language: this.$i18n.locale === 'zh' ? '繁體中文' : 'English',
              brand: this.brand.name,
              brandId: this.brand.id,
              carModel: '',
              // enterpriseUser: "",
              // carReplace: "",
              agreePrivacy: [],
              agreeUsePersonal: [],
              acId: this.form.acId,
              carPlate: '',
              attendees: '',
              appointmentTime: '',
              appointmentTimeItem: '',
            }
            this.$refs.formRef.resetFields()
            setTimeout(() => {
              // this.dialogVisible = false;
              this.dialogVisible2 = false
              const lang = ['繁體中文', 'Traditional Chinese'].includes(formDate_.language) ? 'zh' : 'en'
              this.$router.push({ path: `/succeed?lang=${lang}&v=${strId}` })
              // this.$router.push({ path: "/succeed", query: { lang: _lang } });
            }, 1000)
          } else if (code === 400) {
            this.errorMsg = ['繁體中文', 'Traditional Chinese'].includes(formDate_.language)
              ? message || ''
              : messageEn || message
            this.$message({ message: this.errorMsg || this.$t('home.submitFail'), type: 'error' })
            setTimeout(() => {
              this.dialogVisible2 = false
              this.dialogVisible = true
            }, 500)
          }
        } else {
          document.getElementById('myElement')?.scrollIntoView()
          return false
        }
      })
    },
    // async getTimePeriod(e) {
    //   const {
    //     data: {
    //       code,
    //       data: { timePeriodList1, timePeriodList2 },
    //     },
    //   } = await timePeriodListApi(e)
    //   // console.log(code, timePeriodList1, timePeriodList2)
    //   return { code, timePeriodList1, timePeriodList2 }
    // },
    resetForm() {
      this.$refs.formRef.resetFields()
    },
    goNewPage() {
      window.open('https://www.kamlung.com/privacy-policy?lang=tc', '_blank')
    },
    goNewPage1() {
      window.open('https://www.kamlung.com/copy-of-privacy-policy?lang=tc', '_blank')
    },
    // _______________________
    // openForm() {
    //   this.dialogVisible = true;
    // },
    // openForm2() {
    //   this.dialogVisible1 = true;
    // },
    // ---------------------------
    downloadPDF() {
      const link = document.createElement('a')
      link.href = 'https://ssy.kamlung.net/excel/pv5.pdf'
      link.download = 'filename.pdf'
      link.target = '_blank'
      link.click()
      // document.body.removeChild(link);
    },
    changeLanguage(e) {
      this.$refs.formRef.resetFields()
      this.form.language = e === 'en' ? 'English' : '繁體中文'
    },
    changePhoneAreaCode(v) {
      console.log('v :>>changePhoneAreaCode ', v)
      this.form.phoneAreaCode = v
      // this.form.phone = ''
      // this.$refs.formRef.clearValidate('phone')
      this.$nextTick(() => {
        this.$refs.formRef.validateField('phone')
      })
    },
    changeTitle(v) {
      console.log('v :>>changeTitle ', v)
      this.form.title = v
    },
    changeCar(v) {
      console.log('v :>>changeTitle ', v)
      this.form.carModel = v

      // if (this.form.carModel && this.form.date) this.handleDateChange(this.form.date, this.form.carModel)
    },
    visibleChangeSalesMan(v) {
      if (v && this.salesManList.length === 0) {
        this.getSalesManList(this.form.brandId)
      }
    },
    changeSalesMan(v) {
      console.log('v :>>changeTitle ', v)
      // this.form.salesId = v.userId
      this.form.sales = v
    },
    changeLan(v) {
      console.log('v :>>changeTitle ', v)
      this.form.language = v
    },
    // changeTime(v) {
    //   console.log('v :>>changeTitle ', v)
    //   this.form.timePeriod = v
    // },
    // changeDate(v) {
    //   console.log('v :>>changeTitle ', moment(v).format('YYYY-MM-DD'))
    //   this.form.date = moment(v).format('YYYY-MM-DD')
    //   console.log('changeDatechangeDatechangeDate', this.form.carModel, this.form.date, this.selectedDate)

    //   if (isNaN(new Date(this.form.date).getTime())) {
    //     this.form.date = ''
    //     this.timePeriodList = []
    //     this.form.timePeriod = ''
    //     this.dateText = ''
    //     this.noDataText = '暫無日期可選'
    //   }

    //   // if (this.form.carModel && this.form.date) this.handleDateChange(this.form.date, this.form.carModel)
    // },
    // changeTimeVer() {
    //   if (!this.form.carModel || !this.form.date) {
    //     this.$message({
    //       showClose: true,
    //       message: '請先 選擇車型 和 選擇日期',
    //       type: 'warning',
    //     })
    //   }
    // },
  },
}
</script>

<style lang="scss">
/* 使用 :deep 或全局样式穿透 */
.hide-adjacent-months .next-month,
.hide-adjacent-months .prev-month {
  visibility: hidden;
}

// .el-select-dropdown__item.selected {
//   color: #d97316;
// }

// .el-month-table td.disabled:hover .cell {
//   color: #C0C4CC;
// }

// .el-month-table td:hover .cell {
//   color: #d97316;
// }

// .el-month-table td.today .cell {
//   color: #d97316;
// }

// .el-date-picker__header-label:hover {
//   color: #d97316;
// }

// .el-date-table td.disabled:hover span {
//   color: #C0C4CC;
// }

// .el-date-table td:hover span {
//   color: #d97316;
// }

// .el-date-table td.today span {
//   color: #d97316;
// }

// .el-date-table td.current:not(.disabled) span {
//   background: #d97316;
// }

.row-expand-cover td .el-table__expand-icon {
  visibility: hidden;
}

.custom-class-dialog1 {
  background-color: #f56c6c;

  .el-dialog__body {
    padding: 22px 15px 48px 15px !important;
  }
}

input[aria-hidden='true'] {
  display: none !important;
}

.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
  box-shadow: none !important;
}
</style>

<style lang="scss" scoped>
@import 'element-ui/lib/theme-chalk/display.css';

.el-form-item {
  margin-bottom: 26px !important;
}

@media (min-width: 400px) {
}

@media (min-width: 768px) {
}

@media (min-width: 1024px) {
}

@media (max-width: 768px) {
  /* 平板样式 */
}

@media (max-width: 1024px) {
  /* 桌面样式 */
}

@media (max-width: 470px) {
  .img-bg {
    aspect-ratio: 3 / 9;
  }
}

@media (max-width: 440px) {
  .img-bg {
    aspect-ratio: 3 / 10;
  }
}

@media (max-width: 390px) {
  .img-bg {
    aspect-ratio: 3 / 12;
  }
}

.contaier {
  padding: 60px 0;
  background-color: #fff;

  ::v-deep .cLoading .el-dialog {
    border-radius: 10px !important;
    background: none !important;
    background-color: rgba(000, 000, 000, 0.6) !important;
  }

  [aria-hidden='true'] {
    display: none !important;
  }

  .form-box {
    // padding: 30px;
    // border-radius: 5px;
    .title {
      font-family: 'icaurFontBold', sans-serif;
    }

    width: 92%;
    margin: 0 auto;
    max-width: 1200px;

    .phone-box {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;

      .phone-sum {
        width: 100px;
        margin-right: 20px;
        // padding-top: 10px;
        font-size: 1.1rem !important;
        // line-height: 1.2rem !important;
        font-weight: 400;
      }

      .phone- {
        flex: 1;
      }
    }

    .note {
      color: #999;
    }

    .note:before {
      content: '*';
      color: #f56c6c;
      margin-right: 4px;
    }

    ::v-deep .el-input {
      font-size: 1.05rem !important;
    }

    ::v-deep .el-form-item__label {
      font-size: 1.15rem !important;
      line-height: 1.6rem !important;
      font-weight: 400;
    }

    ::v-deep .el-radio__label {
      font-size: 1.15rem !important;
      // line-height: 1.2rem !important;
      font-weight: 400;
    }

    ::v-deep .el-radio {
      // margin-right: 72px !important ;
      padding-top: 10px;
      padding-bottom: 10px;
      padding-right: 30px !important;
    }

    ::v-deep .el-radio__inner {
      border-color: #000 !important;
      transform: scale(1.5);
    }

    ::v-deep .el-radio-group {
      padding-left: 4px !important;
    }

    ::v-deep .el-checkbox__inner {
      border-color: #000 !important;
      // background-color: #000 !important ;
      transform: scale(1.5);
      // width: 22px !important;
      // height: 22px !important;
    }

    ::v-deep .el-checkbox__label {
      font-size: 1.05rem !important;
      line-height: 1.6rem !important;
      padding-left: 15px !important;
      white-space: pre-wrap;
      color: #000;
      // line-height
      font-weight: 400;
    }

    ::v-deep .el-checkbox-group {
      padding-left: 4px !important;
    }

    ::v-deep .el-radio__input.is-checked + .el-radio__label {
      color: #000 !important;
    }

    ::v-deep .el-radio__input.is-checked .el-radio__inner {
      background: #000 !important;
    }

    ::v-deep .is-checked .el-checkbox__inner {
      background-color: #000 !important;
      // border-color: #409EFF;
    }

    .checkbox-box {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .checkbox- {
        width: 20px;
      }

      .text {
        padding-left: 10px;
        flex: 1;
        font-size: 1.1rem !important;
        line-height: 1.8rem !important;
        font-weight: 400;
      }
    }

    .to-page {
      cursor: pointer;
      text-decoration: underline;
    }

    ::v-deep .el-input__inner {
      border: none !important;
      border-radius: 0 !important;
      border-bottom: #666 1px solid !important;
    }

    // ::v-deep .el-textarea__inner {
    //   border: none !important;
    //   border-radius: 0 !important;
    //   border-bottom: #666 1px solid !important;
    // }

    ::v-deep .is-error .el-input__inner {
      border-bottom: #f56c6c 2px solid !important;
    }

    .el-checkbox {
      display: flex !important;
      // justify-content: space-between;
      align-items: center;
    }
  }

  .btn-box {
    padding-top: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: center;

    .btn {
      width: 200px;
      line-height: 40px;
      border-radius: 20px;
      cursor: pointer;
    }
  }
}

::v-deep.el-select-dropdown__item {
  font-size: 1.1rem !important;
  // line-height: 1.2rem !important;
  font-weight: 400;
}

.dialog-box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .icon-check {
    font-size: 60px;
    font-weight: 600;
    color: #fff;
  }

  .title {
    padding-top: 10px;
    font-size: 16px;
    color: #fff;
  }
}

.dialog-box2 {
  padding-top: 5px;
  padding-bottom: 30px;
}

.dialog-box1 {
  .iframe {
    // white: 100%;
  }
}
</style>
